export default __webpack_public_path__ + "static/media/Zukas' Prized Helm.78a18faf.jpg";